import { render, staticRenderFns } from "./EditPage_New.vue?vue&type=template&id=2069ee43&"
import script from "./EditPage_New.vue?vue&type=script&lang=js&"
export * from "./EditPage_New.vue?vue&type=script&lang=js&"
import style0 from "./EditPage_New.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports